import { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { FaRegPlusSquare } from "react-icons/fa";
import Swal from "sweetalert2";

const Add = ({apiUrl}) => {
  const navigate = useNavigate();
  const [name, setName] = useState('');
  const [desc, setDesc] = useState('');

  const submitHandler = async(e)=> {
    e.preventDefault();
    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers:{
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({name, desc})
      });
      if(response.ok){
        Swal.fire({
          title: 'Gym Saved',
          text: 'Gym details have been saved',
          icon: 'success',
          showCancelButton: true,
          confirmButtonText: 'Okay',
          cancelButtonText: 'Add One More',
          customClass: {
            confirmButton: 'bg-success',
            cancelButton: 'bg-danger',
          },
        }).then((result) => {
          if (result.isConfirmed) {
            navigate('/');
          }else{
            navigate(0);
          }
        });
      }else{
        const result = await response.json();
        throw new Error(result.message);
      }
    } catch (error) {
      Swal.fire(
        'Error!',
        error.message,
        'error'
      );
    }
  }

  return (
    <div className='container mt-3'>
      <div className='row'>
        <div className='offset-md-3 col-md-6'>
          <form className='container mt-3' onSubmit={submitHandler}>
            <h1>
              Add Gym
              <Link to="/" className="btn btn-primary btn-sm mb-3 float-end">
                <FaRegPlusSquare /> Back to Gym List
              </Link>
            </h1>
            <div className='mb-3'>
              <input type="text" placeholder='Gym Name *' className='form-control' value={name} onChange={(e)=> setName(e.target.value)} required />
            </div>
            <div className='mb-3'>
              <input type="text" placeholder='Gym Description *' className='form-control' onChange={(e)=> setDesc(e.target.value)} value={desc} required />
            </div>
            <div className='mb-3'>
              <button type="button" className='btn btn-success btn-sm'>Submit</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}

export default Add